import types from '../actions';

const initialState = {
  tracks: [],
  albums: [],
  artists: [],
  users: []
};

export default function searchResult(state = initialState, action) {
  switch (action.type) {
    case types.TRACKS_RESULT:
      return {
        ...state,
        tracks: action.payload
      };
    case types.ALBUMS_RESULT:
      return {
        ...state,
        albums: action.payload
      };
    case types.ARTISTS_RESULT:
      return {
        ...state,
        artists: action.payload
      };
    case types.USERS_RESULT:
      return {
        ...state,
        users: action.payload
      };
    case types.CHANNELS_RESULT:
      return {
        ...state,
        channels: action.payload
      };
    default:
      return state;
  }
}
